module.exports = __webpack_public_path__ + "static/img/5137_phase_function_Paper_Points.04a9ee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5137_phase_function_Paper_Points.png
// module id = Rxy6
// module chunks = 0